<div class="portal__content section" role="main">
  <div class="container">
    <router-outlet></router-outlet>
  </div>
</div>
